"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubType = void 0;
var SubType;
(function (SubType) {
    SubType["DEFAULT"] = "DEFAULT";
    SubType["EXECUTIVE"] = "EXECUTIVE";
})(SubType || (exports.SubType = SubType = {}));
//# sourceMappingURL=Dashboard.js.map